<template>
    <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
        <div class="form-group mb-2">
            <label class="d-block font-weight-bold">
                {{ label }}
                <span v-if="required" class="text-danger">*</span>
            </label>
            <div>
                <textarea
                    v-model="item"
                    @input="
                        $emit('input', item);
                        $emit('change');
                    "
                    class="form-control"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    :required="required"
                    :disabled="disabled"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "value",
        "label",
        "required",
        "grid",
        "readonly",
        "placeholder",
        "mt",
        "disabled",
    ],
    data() {
        return { item: null };
    },
    beforeMount() {
        this.item = this.value;
    },
    watch: {
        value(n, o) {
            this.item = n;
        },
    },
};
</script>
